<template>
    <div class="detail-item">
        <div class="type">
            <p>
                {{ `quote-results.static.policy_includes` | __ }}
            </p>
        </div>
        <ul
            class="policy-details"
            v-for="(props, branch_index) in innerProps"
        >
            <li
                v-if="branch_index === branch"
                v-for="(value, key) in props"
                class="text-xs md:text-base"
            >
                {{ `quote-results.${type}.${branch}_${key}` | __ }}
                <div v-if="value !== -1">
                    {{ getValueOrUnlimited(value) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        innerProps: Object,
        type: String,
        currency: String,
        branch: String
    },
    methods: {
        getValueOrUnlimited(value) {
            if (value === null) {
                return this.$trans("quote-results.static.notAvailable");
            } else if (value === -1) {
                return this.$trans("quote-results.static.unlimited");
            }
            return `${value} ${this.currency}`;
        },
    }
};
</script>

<style lang="scss" scoped>
.detail-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    //gap: 7px;
    width: 100%;
}

.policy-details {
    list-style: none;
    display: flex;
    flex-direction: column;
    width: 100%;

    li {
        display: flex;
        justify-content: space-between;
    }
}
</style>
